import api from './api';
import app from './app';


const _auth = {
    token:null,
    isLoggedIn:false,
    isSuper:false,
    userId:null,
    name:null,
    username:null,
    defaultFeatures :{
        booking: false,
        prices:false,
        billing:false,
        tasks:false,
        super:false,
        cfg:false ,
        admin:false
    },
    features:{},
    hasTokenStored:false
}



function isLoggedIn() {
    return _auth.isLoggedIn;
}

async function logIn(username, password) {
    let tokenInfo = await api.publicCall('POST', 'login', {username,password});
    if (!tokenInfo.ok)
        return;


    _auth.isLoggedIn = true;
    _auth.token = tokenInfo.data.token;
    _auth.hasTokenStored =true;
    localStorage.setItem('token',_auth.token) ;
    api.setToken(_auth.token);

    await fetchUserInfo();
}


function logOut() {
    _auth.isLoggedIn = false;
    _auth.features ={..._auth.defaultFeatures};
    _auth.user = null;
    _auth.isSuper = false;
    _auth.userId=null;
    _auth.name=null;
    _auth.username=null;
    _auth.hasTokenStored =false;

    localStorage.removeItem('token') ;
    app.setUsername('');
    api.setToken('');
}


function hasFeature(featureName) {
    return _auth.isSuper || (_auth.features[featureName]??false);
}

async function fetchUserInfo () {
    _auth.user = null;
    let userInfo  = await api.call('GET','user',null, false);
    if (!userInfo.ok)  return;

    _auth.isSuper  = userInfo.data.is_super;
    _auth.name     = userInfo.data.name;
    _auth.username = userInfo.data.username;
    _auth.userId   = userInfo.data.id;
    _auth.features ={..._auth.defaultFeatures};

    for(let feature of userInfo.data.features )
        _auth.features[feature]=true;
    app.setUsername(_auth.username);
}


async function loadStoredSession() {
    _auth.isLoggedIn =false;
    _auth.token = localStorage.getItem('token') ;

    if(_auth.token) {
        api.setToken(_auth.token);
        await fetchUserInfo();
        if (!_auth.userId)
            logOut();
        else {
            _auth.isLoggedIn =true;
            _auth.hasTokenStored=true;
        }
    }
}

function hasTokenStored() {
    return _auth.hasTokenStored;
}

async function changePassword(password) {
    await api.post('user/change-password', {password})
}

function isSuper() {
    return _auth.isSuper;
}



if (localStorage.getItem('token'))
    _auth.hasTokenStored = true;


export default {
    isLoggedIn,
    logIn,
    logOut,
    hasFeature,
    hasTokenStored,
    loadStoredSession,
    changePassword,
    isSuper
};
